import * as Yup from "yup";

export const dataModel = {
  dateInit: "",
  dateEnd: "",
  type: "",
  viveroUuid: "",
};

export const validationDataModel = Yup.object().shape({
  dateInit: Yup.date().optional("forms.validations.required"),
  dateEnd: Yup.date().optional("forms.validations.required"),
  type: Yup.string().required("forms.validations.required"),
  viveroUuid: Yup.string().optional("forms.validations.required"),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
